"use strict";
/** @module AccountApi */
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
/**
 * Mixin class for account/join site agency API calls.
 */
var AgencyMixin = /** @class */ (function () {
    function AgencyMixin() {
    }
    /**
     * Search agencies
     * @param limit
     * @param page
     * @param name
     * @param callback
     */
    AgencyMixin.prototype.getAgencies = function (limit, page, name, callback, id) {
        var _this = this;
        var urlParams = {};
        if (limit != null) {
            urlParams['limit'] = limit;
        }
        if (page != null) {
            urlParams['page'] = page;
        }
        if (name != null) {
            urlParams['name'] = name;
        }
        if (id) {
            urlParams['id'] = id;
        }
        // const wrappedCallback = (request: HttpRequest, response: HttpResponse) => {
        //   callback((this as any).apiResultFromParse(response, SearchAgency.parse));
        // };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, function (o) { return models_1.PageResult.parse(o, 'agencies', models_1.SearchAgency.parse); }));
        };
        this.http.get('/agencies', urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Get specific agency.
     * @param id
     * @param callback
     */
    AgencyMixin.prototype.getAgency = function (id, callback) {
        var _this = this;
        var urlParams = { id: id };
        // const wrappedCallback = (request: HttpRequest, response: HttpResponse) => {
        //   callback((this as any).apiResultFromParse(response, SearchAgency.parse));
        // };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, function (o) { return models_1.PageResult.parse(o, 'agencies', models_1.SearchAgency.parse); }));
        };
        this.http.get('/agencies', urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Get groups in an agency by ID
     * [Endpoint spec](https://gitlab.bryx.com/bryx911/bryx911-spec/blob/master/Actions/GetAgencyGroups.md)
     * @param agencyId
     * @param type
     * @param limit
     * @param page
     * @param sortConfig ex: { column: 'name', direction: 'desc' } Unused.
     * @param search
     * @param callback
     */
    AgencyMixin.prototype.getAgencyGroups = function (agencyId, type, limit, page, sortConfig, search, callback) {
        var _this = this;
        var urlParams = {
            order: 'desc',
        };
        if (sortConfig != null) {
            urlParams['order'] = sortConfig.direction;
        }
        if (type != null) {
            urlParams['type'] = models_1.AgencyGroupTypeEnum[type];
        }
        if (limit != null) {
            urlParams['limit'] = limit;
        }
        if (page != null) {
            urlParams['page'] = page;
        }
        if (search != null) {
            urlParams['search'] = search;
        }
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, function (o) { return models_1.PageResult.parse(o, 'groups', models_1.AgencyGroup.parse); }));
        };
        this.http.get("/agencies/" + agencyId + "/groups", urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    return AgencyMixin;
}());
exports.default = AgencyMixin;
//# sourceMappingURL=AgencyMixin.js.map